import React from "react";
import { SkeletonComponents } from ".";

const HeaderSkeleton = (): React.ReactElement => {
  return (
    <header className="header-section" aria-hidden="true">
      <div className="flex items-center justify-between px-4 xs:px-5 bg-white py-1 xs:py-2.5">
        <div className="flex items-center gap-3.5 xs:gap-6.75">
          <SkeletonComponents.skeleton className="h-8 xs:h-11.25 w-26.25 xs:w-40 rounded-md" />
          <SkeletonComponents.skeleton className="h-4 w-4 rounded-sm" />
        </div>

        <div className="flex max-[376px]:gap-1 gap-2.5">
          <div className="flex flex-none gap-0.5 items-center">
            <div className="hidden md:flex size-11 items-center justify-center">
              <SkeletonComponents.skeleton className="size-5 rounded-full" />
            </div>
            <div className="hidden md:flex size-11 items-center justify-center">
              <SkeletonComponents.skeleton className="size-5 rounded-full" />
            </div>
            <div className="flex size-11 items-center justify-center">
              <SkeletonComponents.skeleton className="size-5 rounded-full" />
            </div>
          </div>
          <SkeletonComponents.skeleton className="size-8 xs:size-11 rounded-full" />
        </div>
      </div>
    </header>
  );
};

export default HeaderSkeleton;
